import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <div className="policy-page-container">
      <div className="policy-header">
        <h1>Privacy Policy</h1>
      </div>
      
      <div className="policy-content privacy-policy">
        <p>This privacy notice explains how langjee.com collects, uses, and protects the personal information you provide through our website and any language learning services or products we offer. It applies solely to information collected via our website (except where noted otherwise) and describes the following:</p>
        <ul>
          <li>What information we collect</li>
          <li>With whom it is shared</li>
          <li>How you can access or correct your information</li>
          <li>How we secure your data</li>
          <li>How cookies are used</li>
          <li>How policy changes will be communicated</li>
          <li>How to address concerns regarding misuse of personal data</li>
        </ul>

        <hr />

        <h3>1. Information Collection, Use, and Sharing</h3>
        <ul>
          <li><strong>What We Collect:</strong>
            <ul>
              <li><strong>Personal Data:</strong> When you register or subscribe, we ask for details such as your name, email address, username, learning language preferences, and any additional demographic information you choose to provide.</li>
              <li><strong>Usage Data:</strong> We record how you interact with our site—for example, which pages you visit, language learning activities, saved words or characters, and other learning-related actions you take.</li>
              <li><strong>Payment Data:</strong> When you make a payment for subscription services, your payment details are processed securely by our trusted third-party processor (Stripe).</li>
            </ul>
          </li>
          <li><strong>How We Use Your Information:</strong>
            <ul>
              <li>To operate and improve our language learning platform.</li>
              <li>To personalize your learning experience based on your chosen language and proficiency level.</li>
              <li>To process your registration or subscription requests.</li>
              <li>To send you updates, offers, or important notices (unless you opt out).</li>
              <li>To analyze usage trends and enhance our services.</li>
            </ul>
          </li>
          <li><strong>How We Share Your Information:</strong>
            <ul>
              <li>We do not sell or rent your personal data.</li>
              <li>Your information is shared only when necessary to fulfill your requests (for example, with our payment processor) or as required by law.</li>
              <li>Aggregated (non-personal) data may be shared with trusted partners for analytical purposes to improve our language learning offerings.</li>
            </ul>
          </li>
        </ul>

        <hr />

        <h3>2. Your Access to and Control Over Your Information</h3>
        <p>You have the right to:</p>
        <ul>
          <li>View the information we hold about you.</li>
          <li>Update or correct any inaccuracies.</li>
          <li>Request deletion of your data.</li>
          <li>Opt out of receiving marketing communications.</li>
        </ul>
        <p>To exercise any of these rights, please contact us as described in Section 6.</p>

        <hr />

        <h3>3. Registration and Payment</h3>
        <p>Certain services or products on our website may require you to register and provide personal information. The information you supply during registration (such as your name, email, and language preferences) is used to manage your account, personalize your learning experience, and to communicate with you about our offerings. Similarly, if you subscribe to our premium service, your payment information is handled securely by our trusted third-party processor.</p>

        <hr />

        <h3>4. Cookies</h3>
        <p>We use cookies—small data files stored on your device—to enhance your experience. Cookies help us:</p>
        <ul>
          <li>Recognize you on subsequent visits.</li>
          <li>Remember your language preferences and learning progress.</li>
          <li>Analyze site usage to improve our language learning services.</li>
        </ul>
        <p>Some third parties may also use cookies on our site; however, we have no control over these. You can adjust your browser settings to manage or block cookies, although this may affect your experience on our website.</p>

        <hr />

        <h3>5. Security</h3>
        <p>We take appropriate measures to protect your personal information both online and offline. This includes:</p>
        <ul>
          <li>Encrypting sensitive data during transmission.</li>
          <li>Restricting access to personal data to employees who require it for their job functions.</li>
          <li>Storing data on secure servers.</li>
        </ul>

        <hr />

        <h3>6. Contact Information</h3>
        <p>If you have any questions, concerns, or wish to exercise your rights regarding your personal data, please contact us at:</p>

        <p><strong>Email:</strong> <a href="mailto:support@langjee.com">support@langjee.com</a></p>

        <hr />

        <h3>7. Links and Third-Party Content</h3>
        <p>Our website may include links to external sites. We are not responsible for the privacy practices or content of these sites; please review their privacy notices before providing any personal data. Additionally, while much of the content on our site is proprietary, some third-party material may be used with proper attribution.</p>

        <hr />

        <h3>8. AI Language Learning Features</h3>
        <p>Our application includes AI-powered language learning features like chatbots and story generators. These features may process your language inputs to provide personalized learning experiences. Data collected through these interactions is used solely to improve the quality of our language learning services and is subject to the same privacy protections as all other data we collect.</p>

        <hr />

        <h3>9. Additional Disclosures</h3>
        <p>We comply with all applicable privacy laws and regulations—including those related to digital marketing and international data transfers. If you believe we are not abiding by this privacy notice, please contact us immediately.</p>

        <hr />

        <h3>10. Changes to This Privacy Notice</h3>
        <p>We may update this privacy notice from time to time. Any changes will be posted on our website and will become effective immediately upon publication.</p>
      </div>
      
      <div className="policy-footer">
        <Link to="/" className="back-to-home">Back to Home</Link>
        <div className="footer-links">
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 